import { render } from "./InsertarObservacion.vue?vue&type=template&id=ede24a5e&scoped=true"
import script from "./InsertarObservacion.vue?vue&type=script&lang=js"
export * from "./InsertarObservacion.vue?vue&type=script&lang=js"

import "./InsertarObservacion.vue?vue&type=style&index=0&id=ede24a5e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede24a5e"]])

export default __exports__